import { ZoneProjectsRetrievalFilter } from "@planzone/dto";

function areZoneProjectsRetrievalFilters(
  firstFilter: ZoneProjectsRetrievalFilter,
  secondFilter: ZoneProjectsRetrievalFilter,
): boolean {
  return (
    firstFilter.isOpen === secondFilter.isOpen &&
    firstFilter.limit === secondFilter.limit &&
    firstFilter.creationDate === secondFilter.creationDate &&
    firstFilter.isSortedAlphabetically ===
      secondFilter.isSortedAlphabetically &&
    firstFilter.isSortedByJoinedProject === secondFilter.isSortedByJoinedProject
  );
}

export { areZoneProjectsRetrievalFilters };
